import { useTranslation } from 'next-i18next';

const useGetComparisonSection = () => {
  const { t } = useTranslation('fe_er_motorcycle_trip_page');

  const bikeOnlyTab = {
    label: t('fe_er_motorcycle_trip_page:bike_only'),
    value: 1,
    price: t('fe_er_motorcycle_trip_page:start_bike_only'),
  };
  const selfDriveTab = {
    label: t('fe_er_motorcycle_trip_page:self_drive'),
    value: 2,
    price: t('fe_er_motorcycle_trip_page:start_self_drive'),
  };
  const guidedTab = {
    label: t('fe_er_motorcycle_trip_page:guided'),
    value: 3,
    price: t('fe_er_motorcycle_trip_page:start_guided'),
  };
  const getTourInclusionsTabs = (toursType) => {
    const tabs = [bikeOnlyTab];
    if (toursType.self_drive_tours.length > 0) {
      tabs.push(selfDriveTab);
    }
    if (toursType.guided_tours.length > 0) {
      tabs.push(guidedTab);
    }
    return tabs;
  };
  const getTourInclusions = (toursType) => {
    let tourInclusions = [
      {
        inclusion: t('fe_er_motorcycle_trip_page:late_model_motorcycle_rental'),
        bikeOnly: true,
      },
      {
        inclusion: t('fe_er_motorcycle_trip_page:motorcycle_friendly_hotels'),
        bikeOnly: false,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:ability_to_customize_tour_trip',
        ),
        bikeOnly: true,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:route_with_the_best_motorcycle_roads',
        ),
        bikeOnly: false,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:EagleRider_leather_Bound_road_book',
        ),
        bikeOnly: false,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:support_vehicle_with_luggage_transportation',
        ),
        bikeOnly: false,
      },
      {
        inclusion: t('fe_er_motorcycle_trip_page:spare_motorcycle'),
        bikeOnly: false,
      },
      {
        inclusion: t('fe_er_motorcycle_trip_page:professional_support_driver'),
        bikeOnly: false,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:professional_bi_Lingual_tour_guide',
        ),
        bikeOnly: false,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:group_riding_experience_with_social_events',
        ),
        bikeOnly: false,
      },
      {
        inclusion: t('fe_er_motorcycle_trip_page:daily_breakfast_included'),
        bikeOnly: false,
      },
      {
        inclusion: t('fe_er_motorcycle_trip_page:all_fuel_on_riding_days'),
        bikeOnly: false,
      },
      {
        inclusion: t('fe_er_motorcycle_trip_page:welcome_reception_and_dinner'),
        bikeOnly: false,
      },
      {
        inclusion: t(
          'fe_er_motorcycle_trip_page:eagleRider_world_famous_farewell_party_experience',
        ),
        bikeOnly: false,
      },
    ];

    if (toursType.self_drive_tours.length > 0) {
      tourInclusions = tourInclusions.map((tourInclusion, index) => {
        if (index < 5) {
          // eslint-disable-next-line no-param-reassign
          tourInclusion.selfDrive = true;
        } else {
          // eslint-disable-next-line no-param-reassign
          tourInclusion.selfDrive = false;
        }
        return tourInclusion;
      });
    }
    if (toursType.guided_tours.length > 0) {
      tourInclusions = tourInclusions.map((tourInclusion) => {
        // eslint-disable-next-line no-param-reassign
        tourInclusion.guided = true;
        return tourInclusion;
      });
    }

    return tourInclusions;
  };

  return [getTourInclusions, getTourInclusionsTabs];
};

export default useGetComparisonSection;
